module.exports = __webpack_public_path__ + "files/framework4-web-applications.0df8e61a.pdf";